import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { VideoTutorialModalPage } from './video-tutorial-modal';

@NgModule({
  declarations: [
    VideoTutorialModalPage,
  ],
  imports: [
    IonicPageModule.forChild(VideoTutorialModalPage),
  ],
})
export class VideoTutorialModalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/video-tutorial-modal/video-tutorial-modal.module.ts